import styled from 'styled-components';

const SidebarHeader = styled.div`
  display: flex;
  padding: 0 15px 0 6px;
  border-bottom: 1px solid #ccc;
`;

export default SidebarHeader;
